import { ToastContainer } from "react-toastify";
import Layout from "./Components/Layout_Components/Layout";
import "react-toastify/dist/ReactToastify.css";
import PopupModal from "./utils/PopupModal";
import { useContext } from "react";
import OTPAuthContext from "./Context/OTPAuthContext";

function App() {
  const { expiredErr } = useContext(OTPAuthContext);
  return (
    <>
      <Layout />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ width: "500px" }}
      />
      <PopupModal data={expiredErr?.data} />
    </>
  );
}

export default App;
